import { render, staticRenderFns } from "./AdminProduct.vue?vue&type=template&id=7ab9f840&scoped=true"
import script from "./AdminProduct.vue?vue&type=script&lang=js"
export * from "./AdminProduct.vue?vue&type=script&lang=js"
import style0 from "./AdminProduct.vue?vue&type=style&index=0&id=7ab9f840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab9f840",
  null
  
)

export default component.exports